<template>
    <div id="paginator" class="btn-group" v-if="shouldPaginate">
        <vue-button class="btn btn-primary btn-outline"
                    icon="cheveron"
                    icon-class="svg-left"
                    :disabled="!prevUrl || loading"
                    @click="page--"/>
        <vue-button class="btn btn-primary btn-outline"
                    icon="cheveron"
                    icon-class="svg-right"
                    :disabled="!nextUrl || loading"
                    @click="page++"/>
    </div>
</template>

<script>
export default {
  props: {
    dataSet: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    shouldPaginate() {
      return !!this.prevUrl || !!this.nextUrl;
    },
  },

  data() {
    return {
      page: this.getPage(),
      prevUrl: false,
      nextUrl: false,
    };
  },

  watch: {
    dataSet() {
      this.page = this.dataSet.meta.current_page;
      this.prevUrl = this.dataSet.links.prev;
      this.nextUrl = this.dataSet.links.next;
    },

    page(page) {
      if (page !== this.getPage()) {
        this.updateUrl(page).broadcast();
      }
    },
  },

  methods: {
    getPage() {
      const params = new URLSearchParams(window.location.search);
      return params.has('page') ? Number(params.get('page')) : 1;
    },

    updateUrl(page) {
      const params = new URLSearchParams(window.location.search);
      params.set('page', page);
      history.pushState(null, '', `?${params.toString()}`);
      return this;
    },

    broadcast() {
      return this.$emit('changed');
    },
  },
};
</script>
